import React, { useEffect, useState, useRef } from "react";
// import moment from "moment-timezone";
import "../../../styles/live-subscriptions/membership-notification.css";
import notificationSound from "../../../assets/vocal-sound/vocal_renewal_reminder.mp3";
// import {
//   CalenderIcon1,
//   CallIcon,
//   LocationIcon1,
//   PersonIcon,
//   RupeeIcon,
//   ClockIconV3,
//   EmailIcon,
// } from "../../../images/icons/icons";
// import {
//   convertStraight,
//   convertThenFormat,
//   formatDateTime,
// } from "../../common-data/Converts";
import MemberBasicInfo from "../MemberBasicInfo";
import ToaserInfo from "../ToaserInfo";
import FooterTags from "../FooterTags";

const RenewalWebhook = ({ userInfoData, setStatsData, setAllDatas }) => {
  const audioRef = useRef(null);
  const wsRef = useRef(null);
  const wsBackoffRef = useRef(2000);
  const processedWebhookEvents = useRef(new Set());

  const [notifications, setNotifications] = useState([]);
  const [activeTab, setActiveTab] = useState(0);

  const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent);

  const playNotificationSound = () => {
    try {
      if (audioRef.current) {
        audioRef.current.currentTime = 0;
        audioRef.current.play().catch((error) => {});
      }
    } catch (error) {}
  };

  const showRenewalNotification = (renewalData) => {
    console.log("renewalData=> ", renewalData);

    const eventId = `${renewalData?.name || ""}_${renewalData?.mobile || ""}_${
      renewalData?.expire_date || ""
    }_${Date.now()}`;

    const now = Date.now();
    const existingEvent = Array.from(processedWebhookEvents.current).find(
      (item) => {
        const [id, timestamp] = item.split("_TIMESTAMP_");
        return (
          id.includes(renewalData?.name || "") &&
          id.includes(renewalData?.mobile || "") &&
          now - parseInt(timestamp) < 10000
        );
      }
    );

    if (existingEvent) {
      return;
    }

    const eventWithTimestamp = `${eventId}_TIMESTAMP_${now}`;
    processedWebhookEvents.current.add(eventWithTimestamp);

    processedWebhookEvents.current.forEach((item) => {
      const [, timestamp] = item.split("_TIMESTAMP_");
      if (now - parseInt(timestamp) > 30000) {
        processedWebhookEvents.current.delete(item);
      }
    });

    const notification = renewalData || {};
    // const notification = {
    //   id: renewalData?.user_id || Date.now() + Math.random(),
    //   user_id: renewalData?.user_id || "",
    //   name: renewalData?.name || "NA",
    //   mobile: renewalData?.mobile || "NA",
    //   email: renewalData?.email || "NA",
    //   gym_name: renewalData?.gym_name || "NA",
    //   gym_id: renewalData?.gym_id || "",
    //   plan_name: renewalData?.plan_name || "NA",
    //   plan_id: renewalData?.plan_id || "",
    //   price: renewalData?.price || 0,
    //   duration: renewalData?.duration || "0",
    //   days_remaining: renewalData?.days_remaining || 0,
    //   start_date: renewalData?.start_date || "",
    //   expire_date: renewalData?.expire_date || "",
    //   created_by: renewalData?.created_by || null,
    //   created_by_name: renewalData?.created_by_name || "NA",
    //   created_by_mobile: renewalData?.created_by_mobile || "NA",
    //   created_by_email: renewalData?.created_by_email || "NA",
    //   date_added:
    //     renewalData?.date_added ||
    //     moment().tz("Asia/Kolkata").format("YYYY-MM-DD HH:mm:ss"),
    //   is_renewal: renewalData?.is_renewal || 0,
    //   timestamp: Date.now(),
    // };

    setNotifications((prev) => {
      const newNotifications = [notification, ...prev];
      return newNotifications;
    });
    playNotificationSound();

    if (setStatsData) {
      setStatsData((prev) => {
        const currentTotal = Number(prev.total) || 0;
        const currentMonthly = Number(prev.monthly) || 0;
        const currentQuaterly = Number(prev.quaterly) || 0;
        const currentHalfYearly = Number(prev.half_yearly) || 0;
        const currentYearly = Number(prev.yearly) || 0;

        const duration = Number(renewalData?.duration) || 0;
        let incrementField = "monthly";

        if (duration <= 30) {
          incrementField = "monthly";
        } else if (duration <= 90) {
          incrementField = "quaterly";
        } else if (duration <= 180) {
          incrementField = "half_yearly";
        } else {
          incrementField = "yearly";
        }

        return {
          ...prev,
          total: currentTotal + 1,
          monthly:
            incrementField === "monthly" ? currentMonthly + 1 : currentMonthly,
          quaterly:
            incrementField === "quaterly"
              ? currentQuaterly + 1
              : currentQuaterly,
          half_yearly:
            incrementField === "half_yearly"
              ? currentHalfYearly + 1
              : currentHalfYearly,
          yearly:
            incrementField === "yearly" ? currentYearly + 1 : currentYearly,
        };
      });
    }

    if (setAllDatas) {
      setAllDatas((prev) => ({
        ...prev,
        allData: [notification, ...prev.allData],
      }));
    }

    setTimeout(() => {
      setNotifications((prev) => {
        const updated = prev.filter((n) => n.id !== notification.id);
        if (activeTab >= updated.length && updated.length > 0) {
          setActiveTab(updated.length - 1);
        }
        return updated;
      });
    }, 95000);
  };

  useEffect(() => {
    const WS_URL = process.env.REACT_APP_ODM_WSS_URL;
    if (!WS_URL || !userInfoData || isIOS()) return;

    let stopped = false;

    const computeChannels = () => {
      try {
        const acc = userInfoData?.account_type;
        const channels = [];

        if (acc === "receptionist" && userInfoData?.gym_id) {
          channels.push(`renewal:gym:${userInfoData.gym_id}`);
        }
        if (acc === "cluster_manager") {
          const userGyms = userInfoData?.gyms?.gyms || userInfoData?.gyms || [];
          if (Array.isArray(userGyms)) {
            userGyms.forEach((g) => {
              const gid = g?.value || g?.gym_id || g?.uid || g;
              if (gid) channels.push(`renewal:gym:${gid}`);
            });
          }
        }
        if (acc === "admin") {
          channels.push("renewal:global");
        }

        return Array.from(new Set(channels));
      } catch {
        return [];
      }
    };

    const connect = () => {
      if (stopped) return;
      try {
        const token = encodeURIComponent(userInfoData?.token || "");
        const ws = new WebSocket(`${WS_URL}?token=${token}&type=renewal`);
        wsRef.current = ws;

        ws.onopen = () => {
          wsBackoffRef.current = 2000;
          const channels = computeChannels();

          try {
            ws.send(
              JSON.stringify({
                type: "SUBSCRIBE",
                channels: channels,
                event_filter: ["renewal_member_checkin"],
              })
            );
          } catch (e) {}
        };

        ws.onmessage = (e) => {
          try {
            const msg = JSON.parse(e.data);

            if (
              msg?.event_type === "renewal_member_checkin" &&
              msg?.data &&
              msg?.status
            ) {
              showRenewalNotification(msg.data);
            } else {
            }
          } catch (err) {}
        };

        ws.onclose = () => {
          if (stopped) return;
          const delay = Math.min(wsBackoffRef.current, 30000);
          setTimeout(connect, delay);
          wsBackoffRef.current = Math.min(wsBackoffRef.current * 2, 30000);
        };

        ws.onerror = () => {
          try {
            ws.close();
          } catch {}
        };
      } catch {
        const delay = Math.min(wsBackoffRef.current, 30000);
        setTimeout(connect, delay);
        wsBackoffRef.current = Math.min(wsBackoffRef.current * 2, 30000);
      }
    };

    connect();

    return () => {
      stopped = true;
      try {
        if (wsRef.current && wsRef.current.readyState === 1) {
          wsRef.current.close();
        }
      } catch {}
    };
  }, [userInfoData]);

  useEffect(() => {
    if (audioRef.current) {
      const audio = audioRef.current;

      audio.addEventListener("loadstart", () => {});

      audio.addEventListener("canplay", () => {});

      audio.addEventListener("canplaythrough", () => {});

      audio.addEventListener("error", (e) => {});

      audio.load();
    }
  }, []);

  useEffect(() => {
    if (notifications.length > 0) {
      setActiveTab(0);
    }
  }, [notifications.length]);

  return (
    <>
      <audio
        ref={audioRef}
        preload="auto"
        src={notificationSound}
        style={{ display: "none" }}
      />

      {notifications.length > 0 && (
        <div className="live-subscription-membership-notifications-container">
          <div className="live-subscription-feed-modal">
            <div className="live-subscription-modal-header">
              <div>
                <h2 className="live-subscription-modal-title">
                  Renewal Reminder Feed
                </h2>
                <p className="live-subscription-active-count">
                  {notifications.length} Renewal Reminders
                </p>
              </div>
              <button
                className="live-subscription-close-modal-btn"
                onClick={() => setNotifications([])}
              >
                ×
              </button>
            </div>

            <div className="live-subscription-tab-navigation">
              {notifications.map((notification, index) => {
                return (
                  <button
                    key={notification.id}
                    className={`live-subscription-tab-item ${
                      index === activeTab ? "active" : ""
                    }`}
                    onClick={() => setActiveTab(index)}
                  >
                    #{index + 1}
                  </button>
                );
              })}
            </div>

            {notifications[activeTab] && (
              <div className="live-subscription-membership-notification-card">
                <MemberBasicInfo
                  rowData={notifications[activeTab]}
                  customTitle="Renewal Reminder Feed"
                />

                <ToaserInfo
                  from="renewals"
                  rowData={notifications[activeTab]}
                />

                <FooterTags
                  from="renewals"
                  rowData={notifications[activeTab]}
                />

                {/* <div className="live-subscription-member-info-section">
                  <div className="live-subscription-member-basic-info">
                    <div className="live-subscription-member-name">
                      <div className="live-subscription-member-name-left">
                        <PersonIcon />
                        {notifications[activeTab]?.name || "NA"}
                      </div>
                      {(notifications[activeTab]?.is_renewal === 1 ||
                        notifications[activeTab]?.is_renewal === 0) && (
                        <span
                          className={`tb-badge ${
                            notifications[activeTab]?.is_renewal === 1
                              ? "tb-existing"
                              : notifications[activeTab]?.is_renewal === 0
                              ? "tb-fresh"
                              : ""
                          }`}
                        >
                          {notifications[activeTab]?.is_renewal === 1
                            ? "Existing Member"
                            : notifications[activeTab]?.is_renewal === 0
                            ? "Fresh"
                            : "NA"}
                        </span>
                      )}
                    </div>
                    <div className="live-subscription-member-phone">
                      <CallIcon />
                      {notifications[activeTab]?.mobile || "NA"}
                    </div>
                    <div className="live-subscription-member-email">
                      <EmailIcon />
                      {notifications[activeTab]?.email || "NA"}
                    </div>
                    <div className="live-subscription-gym-location">
                      <LocationIcon1 />
                      {notifications[activeTab]?.gym_name || "NA"}
                    </div>
                  </div>
                </div>

                <div className="live-subscription-subscription-details">
                  <div className="live-subscription-detail-item">
                    <div className="live-subscription-detail-icon">
                      <CalenderIcon1 />
                    </div>
                    <div className="live-subscription-detail-label">
                      Plan Name
                    </div>
                    <div className="live-subscription-detail-value">
                      {notifications[activeTab]?.plan_name || "-"}
                    </div>
                  </div>

                  <div className="live-subscription-detail-item">
                    <div className="live-subscription-detail-icon">
                      <RupeeIcon />
                    </div>
                    <div className="live-subscription-detail-label">
                      plan price
                    </div>
                    <div className="live-subscription-detail-value highlight">
                      ₹{convertThenFormat(notifications[activeTab]?.price || 0)}
                    </div>
                  </div>

                  <div className="live-subscription-detail-item">
                    <div className="live-subscription-detail-icon">
                      <ClockIconV3 color="gray" />
                    </div>
                    <div className="live-subscription-detail-label">
                      Duration
                    </div>
                    <div className="live-subscription-detail-value">
                      {notifications[activeTab]?.duration || "-"} days
                    </div>
                  </div>
                </div>

                <div className="live-subscription-subscription-details">
                  <div className="live-subscription-detail-item">
                    <div className="live-subscription-detail-icon">
                      <CalenderIcon1 />
                    </div>
                    <div className="live-subscription-detail-label">
                      Start Date
                    </div>
                    <div className="live-subscription-detail-value">
                      {convertStraight(
                        notifications[activeTab]?.start_date || "-"
                      )}
                    </div>
                  </div>

                  <div className="live-subscription-detail-item">
                    <div className="live-subscription-detail-icon">
                      <CalenderIcon1 />
                    </div>
                    <div className="live-subscription-detail-label">
                      Expire Date
                    </div>
                    <div className="live-subscription-detail-value">
                      {convertStraight(
                        notifications[activeTab]?.expire_date || "-"
                      )}
                    </div>
                  </div>

                  <div className="live-subscription-detail-item">
                    <div className="live-subscription-detail-icon">
                      <CalenderIcon1 />
                    </div>
                    <div className="live-subscription-detail-label">
                      reminder date
                    </div>
                    <div className="live-subscription-detail-value">
                      {formatDateTime(
                        notifications[activeTab]?.date_added || "-"
                      )}
                    </div>
                  </div>
                </div>

                <div className="live-subscription-subscription-details">
                  <div className="live-subscription-detail-item">
                    <div className="live-subscription-detail-icon">
                      <PersonIcon />
                    </div>
                    <div className="live-subscription-detail-label">
                      Subscription Added By
                    </div>
                    <div className="live-subscription-detail-value">
                      {notifications[activeTab]?.created_by_name || "NA"}
                    </div>
                  </div>

                  <div className="live-subscription-detail-item">
                    <div className="live-subscription-detail-icon">
                      <CallIcon />
                    </div>
                    <div className="live-subscription-detail-label">
                      Added By Mobile
                    </div>
                    <div className="live-subscription-detail-value">
                      {notifications[activeTab]?.created_by_mobile || "NA"}
                    </div>
                  </div>

                  <div className="live-subscription-detail-item">
                    <div className="live-subscription-detail-icon">
                      <EmailIcon />
                    </div>
                    <div className="live-subscription-detail-label">
                      Added By Email
                    </div>
                    <div className="live-subscription-detail-value lowercase">
                      {notifications[activeTab]?.created_by_email || "NA"}
                    </div>
                  </div>
                </div>

                <div className="live-subscription-total-amount-section">
                  <div className="live-subscription-total-amount-label">
                    <ClockIconV3 color="#1e40af" />
                    Remaining Days
                  </div>
                  <div className="live-subscription-total-amount-value">
                    {notifications[activeTab]?.days_remaining || 0} Days
                  </div>
                </div>

                <div className="live-subscription-membership-badges">
                  <div className="live-subscription-membership-badge regular">
                    Renewal Reminder
                  </div>
                  <div className="live-subscription-membership-badge plan">
                    {notifications[activeTab]?.plan_name || "NA"}
                  </div>
                </div> */}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default RenewalWebhook;
